/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import axios from 'axios';
import store from '@/store';

const API_PREFIX = 'api/v9/';
const CHAT_API_PREFIX = 'chat/api/v1/';

export function axiosProtectedApi (isAuth = false) {
  const axiosApi = axios.create({
    baseURL: `${store.state.AppStore.config.appconfig.WEBSERVICE_URL}${isAuth ? '' : API_PREFIX}`
  });

  axiosApi.CancelToken = axios.CancelToken;
  axiosApi.isCancel = axios.isCancel;

  /*
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  axiosApi.interceptors.request.use(
    config => {
      if (store.state.AuthStore.token) {
        config.headers.Authorization = `Bearer ${
          store.state.AuthStore.token
        }`;
      }
      config.headers['content-type'] = 'application/x-www-form-urlencoded';
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  return axiosApi;
}

export function axiosWebservice () {
  const CancelToken = axios.CancelToken;
  const CancelTokenSource = CancelToken.source();

  const axiosApi = axios.create({
    baseURL: store.state.AppStore.config.appconfig.WEBSERVICE_URL,
    cancelToken: CancelTokenSource.token
  });

  axiosApi.CancelTokenSource = CancelTokenSource;

  /*
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  axiosApi.interceptors.request.use(
    config => {
      config.headers['content-type'] = 'application/x-www-form-urlencoded';
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  return axiosApi;
}

export function axiosServer () {
  const axiosApi = axios.create({
    baseURL: store.state.AppStore.config.baseurl
  });

  axiosApi.CancelToken = axios.CancelToken;
  axiosApi.isCancel = axios.isCancel;

  /*
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  axiosApi.interceptors.request.use(
    config => {
      config.headers['content-type'] = 'application/x-www-form-urlencoded';
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  return axiosApi;
}

export function axiosChatApi (isFormData = false) {
  const axiosApi = axios.create({
    baseURL: `${store.state.AppStore.config.appconfig.APP_URL}${CHAT_API_PREFIX}`
  });

  axiosApi.CancelToken = axios.CancelToken;
  axiosApi.isCancel = axios.isCancel;

  /*
   * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
   */
  axiosApi.interceptors.request.use(
    config => {
      if (store.state.AuthStore.token) {
        config.headers.Authorization = `Bearer ${
          store.state.AuthStore.token
        }`;
      }
      config.headers['content-type'] = isFormData ? 'multipart/form-data' : 'application/json';
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  return axiosApi;
}
